
export class SiteActivationLookup {

    static GetPrimeContract(id: number): string {
        switch (id) {
            case (1): return "Infrastructure";
            case (2): return "VITAL";
            case (3): return "NEURO";
            case (4): return "SLEEP";
            case (5): return "AUTONOMIC";
            case (6): return "ENERGIZE";
            default: return "Unknown";
        }
    }

    static GetMilestone(id: number): string {
        switch (id) {
            case (1): return "Interest Letter/Form/Pack";
            case (2): return "Site Selection Form Complete";
            case (3): return "Contract Initiated";
            case (4): return "Contract Executed";
            case (5): return "Pre-screening Complete";
            case (6): return "Reg Pack Sent";
            case (7): return "Trial Master File Review";
            case (8): return "Regulatory Complete";
            case (9): return "Site Training Complete";
            case (10): return "Central IRB Submission";
            case (11): return "Central IRB Amendment Submission";
            //case (12): return "Central IRB Meeting";
            //case (13): return "Central IRB Amendment Meeting";
            case (14): return "Central IRB Approval";
            case (15): return "Central IRB Amendment Approval";
            case (16): return "Investigational Product Sent";
            case (17): return "Activated for Enrollment";
            case (18): return "First Participant Enrolled";
            case (19): return "First Participant Randomized";
            case (20): return "Enrollment Complete";
            case (21): return "All Participant Follow-Up Complete";
            case (22): return "Site Selection Visit";
            case (23): return "Contracting Initiated";
            case (24): return "Pre-Screening Agreement Executed";
            case (25): return "Site Selected";
            case (26): return "Site Study Addendum Executed";
            case (27): return "Pre-screening Complete";
            case (28): return "Investigator Brochure (IB) Sent";
            case (29): return "Investigator Brochure (IB) Update Sent";
            case (30): return "Site Master Agreement Executed";
            case (31): return "Site Initiation Visit";
            case (32): return "Pre-screening Agreement Initiated";
            case (33): return "Site Master Agreement Initiated";
            case (34): return "Site Study Addendum Initiated";
            case (35): return "Most Recent Randomized";
            case (36): return "Central IRB Approval Posted";
            case (37): return "First Consented";
            default: return "Unknown";
        }
    }

    static GetMetric(id: number): string {
        switch (id) {
            case (1): return "Site Selected  (Time from SSV)";
            case (2): return "Site Master Agreement Executed (Time from Initiated)";
            case (3): return "Pre-screening Agreement Executed (Time from Initiated)";
            case (4): return "Study Addendum Agreement Executed (Time from Initiated)";
            case (5): return "Pre-screening Completed (Time from Pre-screening Agreement Executed)";
            case (6): return "Regulatory Packet Completed (Time from Packet Sent)";
            case (7): return "IRB Approval (Time from Submission)";
            case (8): return "IRB Approval Posted (Time from Submission)";
            case (9): return "SIV (Time from IRB Approval Posted)";
            case (10): return "IP Sent (Time from IRB Approval Posted)";
            case (11): return "Site Activated (Time from Selected)";
            case (12): return "First Randomization (Time from Activated)";
            case (13): return "Study Addendum Initiated (Time from Site Selected)";
            case (14): return "Regulatory Packet Sent (Time from Site Selected)";
            case (15): return "IRB Submission (Time from Site Selected)";
            case (16): return "Time Since Most Recent Randomization";
            case (17): return "Site Activated (Time from Packet Sent)";
            case (18): return "Site Activated (Time from IRB Approval Posted)";
            case (19): return "First Consented (Time from Activated)";
            default: return "Unknown";
        }
    }
}